import React from 'react';
import styles from '../styles/productDrawer.module.css';

const ProductDrawer = ({ product, onClose, onPrint, onMove  }) => {
  if (!product) return null;

  return (
    <div className={styles.drawer}>
      <div className={styles.header}>
        <button onClick={onClose} className={styles.backButton}></button>
        <h2 className={styles.headerText}>Карточка товара</h2>
      </div>

      <div className={styles.tabs}>
        <button className={styles.active}>О товаре</button>
        <button>Операции</button>
        <button>Продажи</button>
        <button>Возвраты</button>
        <button>Приемка</button>
        <button>Динамика</button>
      </div>

      <div className={styles.content}>
        <div className={styles.contentBlock}>
          <div className={styles.photo}></div>
          <div className={styles.left}>
            <div className={styles.contentInfo}>
              <div className={styles.contentInfoName}>{product.name_ru}</div>
              <div className={styles.contentInfoNameSubtitle}>Info</div>
              <div className={styles.textPosition}><p>Цена закупки:</p> <p>{product.purchase_price || '—'}</p></div>
              <div className={styles.textPosition}><p>Цена продажи:</p> <p>{product.sell_price || '—'}</p></div>
              <div className={styles.textPosition}><p>Единица измерения:</p> <p>{product.measure_unit_id || '—'}</p></div>
              <div className={styles.textPosition}><p>Штрихкод:</p> <p>{product.ntin || '—'}</p></div>
              <div className={styles.textPosition}><p>Артикул:</p> <p>{product.article || '—'}</p></div>
            </div>
          </div>

          <div className={styles.right}>
            <h3 className={styles.rightHead}>Дополнительная информация</h3>
            <div className={styles.contentHeadSubtitle}><p>Поставщик:</p> <p>{product.supplier || '—'}</p></div>
            <div className={styles.textPosition}><p>Маркированный товар:</p> <p>{product.is_social ? 'Да' : 'Нет'}</p></div>
            <div className={styles.textPosition}><p>Тип НДС:</p> <p>{product.vat_type || '—'}</p></div>
            <div className={styles.textPosition}><p>Оригинальный артикул:</p> <p>{product.original_article || '—'}</p></div>
            <div className={styles.textPosition}><p>Оригинальный штрихкод:</p> <p>{product.original_barcode || '—'}</p></div>
            <div className={styles.textPosition}><p>Скидка:</p> <p>{product.discount || '—'}</p></div>
          </div>
        </div>  

        <div className={styles.footerButtons}>
          <button className={styles.delete}>Удалить</button>
          <button className={styles.edit}>Редактировать</button>
          <button
            className={styles.move}
            onClick={() => onMove(product)} 
          >
            Перемещение
          </button>
          <button
            className={styles.print}
            onClick={() => onPrint(product)}
          >
            Распечатать штрихкод
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductDrawer;
